export default class InamoveStorage<T> {
    private readonly storageId: string

    constructor(id: string, entry: T) {
        this.storageId = `Inamove/${id}`
        this.setStorage(entry)
    }

    static getInitialStorage<T>(id: string): T | undefined {
        const entry = window.localStorage.getItem(`Inamove/${id}`)

        if (typeof entry === 'string') {
            return JSON.parse(entry)
        } else {
            return undefined
        }
    }

    getStorage = (): T => {
        const entry = window.localStorage.getItem(this.storageId)

        if (typeof entry === 'string') {
            return JSON.parse(entry)
        } else {
            throw new Error(`Inamove::InamoveStorage => could not get entry with id "${this.storageId}`)
        }
    }

    setStorage = (entry: T) => {
        window.localStorage.setItem(this.storageId, JSON.stringify(entry))
    }
}
